// extracted by mini-css-extract-plugin
export default {"heading":"Customers_heading__jf3US","text-orange":"Customers_text-orange__ps8ww"};